(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/coupon/stat-row.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/coupon/stat-row.js');
"use strict";


const show1X2Statistics = (items, label, outcomes) => React.createElement("div", {
  className: ""
}, React.createElement("span", {
  className: "label"
}, label), React.createElement("div", {
  className: "simple-row right"
}, items.map((item, i) =>
React.createElement("div", {
  className: "stat-odds-part",
  key: i
}, outcomes[i].outcomeNumber ? item : ''))));
const showSolStatistics = (items, label) => {
  let sol = "".concat(items[0], ", ").concat(items[1]);
  if (sol.charAt(0) === ',') {
    sol = sol.substr(1);
  }
  if (sol.charAt(sol.length - 2) === ',') {
    sol.substr(0, sol.length - 2);
  }
  if (sol.length < 2) {
    return React.createElement("div", {
      className: ""
    });
  }
  return React.createElement("div", {
    className: ""
  }, React.createElement("span", {
    className: "label"
  }, label), React.createElement("div", {
    className: "simple-row right"
  }, sol));
};
const showInfo = statData => {
  if (statData.extraInfo) {
    return React.createElement("div", {
      className: "match-comment statistic-block"
    }, statData.extraInfo);
  }
  return React.createElement("span", null);
};
class StatRow extends React.Component {
  render() {
    const _this$props = this.props,
      isVisible = _this$props.isVisible,
      type = _this$props.type,
      statData = _this$props.statData,
      outcomes = _this$props.outcomes,
      label = _this$props.label;
    if (!isVisible) {
      return React.createElement("div", null);
    }
    let items;
    switch (type) {
      case 'svf':
        items = statData ? ["".concat(statData.one, "%"), "".concat(statData.x, "%")] : ['-', '-'];
        if (outcomes.length === 3) {
          items.push(statData ? "".concat(statData.two, "%") : '-');
        }
        return show1X2Statistics(items, label, outcomes);
      case 'odds':
        items = statData ? [statData.one, statData.x] : ['-', '-'];
        if (outcomes.length === 3) {
          items.push(statData ? statData.two : '-');
        }
        return show1X2Statistics(items, label, outcomes);
      case 'sol':
        items = [statData !== null && statData !== void 0 && statData.sport ? statData.sport.name : '', statData !== null && statData !== void 0 && statData.league ? statData.league.name : ''];
        return showSolStatistics(items, label);
      case 'info':
        return showInfo(statData);
      default:
        return React.createElement("div", null);
    }
  }
}
svs.challenge.StatRow = StatRow;

 })(window);